<p-card>
  <ng-template pTemplate="header">
    @if (trustedImageUrl) {
      <img [src]="trustedImageUrl" [alt]="contactData?.person?.nachname" (error)="handleImageError($event)" />
    }
  </ng-template>
  <ng-template pTemplate="title">{{ contactData?.person?.vorname }} {{ contactData?.person?.nachname }}</ng-template>
  <ng-template pTemplate="subtitle">
    <div class="h-12">{{ jobTitle }}</div>
  </ng-template>
  <div class="flex flex-col gap-2">
    @if (contactData?.email) {
      <p-button
        class="no-padding"
        severity="primary"
        [text]="true"
        iconPos="left"
        [label]="contactData?.email"
        (click)="openEmail(contactData?.email)"
      >
        <span class="material-symbols-outlined">mail</span>
      </p-button>
    }
    @if (contactData?.telefon) {
      <p-button severity="primary" [text]="true" iconPos="left" [label]="contactData?.telefon" (click)="openPhoneNumber(contactData?.telefon)">
        <span class="material-symbols-outlined">phone_enabled</span>
      </p-button>
    }
  </div>
</p-card>
